import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="header-area header-two">
      {/* Top Header */}
      <div className="top-header-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 col-md-12">
              <div className="social-link">
                <a href="https://www.facebook.com/profile.php?id=100041233227111" target="_blank" rel="noreferrer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#" target="_blank" rel="noreferrer">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#" target="_blank" rel="noreferrer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="#" target="_blank" rel="noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-9 col-md-12 p-0">
              <div className="row align-items-center">
                <div className="col-lg-4 col-sm-4 p-0">
                  <div className="contact-info">
                    <div className="contact-info-content">
                      <p>call us:</p>
                      <a href="tel:+919823020019">+91 9823020019</a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 p-0">
                  <div className="contact-info">
                    <div className="contact-info-content">
                      <p>mail us:</p>
                      <a href="mailto:info@desalepatil.in">info@desalepatil.in</a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 p-0">
                  <div className="contact-info">
                    <div className="contact-info-content">
                      <p>Open Hours:</p>
                      <a href="#">Mon-Fri: 8 am – 7 pm</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <div className="main-navbar-area">
        <div className="constik-responsive-nav">
          <div className="container">
            <div className="constik-responsive-menu">
              <div className="logo">
                <Link to="/" onClick={closeMobileMenu}>
                  <img src="/assets/img/logo2.webp" className="logo1" alt="logo" />
                  <img src="/assets/img/logo2.webp" className="logo2" alt="logo" />
                </Link>
              </div>
              
              {/* Hamburger Menu Icon */}
              <button 
                className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
                onClick={toggleMobileMenu}
                aria-label="Toggle menu"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu Sidebar */}
        {isMobileMenuOpen && (
          <>
            <div className="mobile-menu-backdrop" onClick={closeMobileMenu}></div>
            <div className="mobile-menu-sidebar">
              <Link to="/" className="mobile-navbar-brand" onClick={closeMobileMenu}>
                <img src="/assets/img/ddlogo1.webp" width="150" alt="Logo" />
              </Link>
              <ul className="mobile-navbar-nav">
                <li className="mobile-nav-item">
                  <Link to="/" className={`mobile-nav-link ${isActive('/')}`} onClick={closeMobileMenu}>
                    Home
                  </Link>
                </li>
                <li className="mobile-nav-item">
                  <Link to="/projects" className={`mobile-nav-link ${isActive('/projects')}`} onClick={closeMobileMenu}>
                    Our Projects
                  </Link>
                </li>
                <li className="mobile-nav-item">
                  <Link to="/about" className={`mobile-nav-link ${isActive('/about')}`} onClick={closeMobileMenu}>
                    About Us
                  </Link>
                </li>
                <li className="mobile-nav-item">
                  <Link to="/contact" className={`mobile-nav-link ${isActive('/contact')}`} onClick={closeMobileMenu}>
                    Contact Us
                  </Link>
                </li>
              </ul>
              <div className="mobile-menu-footer">
                <a className="mobile-primary-btn" href="/assets/dp.pdf" target="_blank" rel="noreferrer" onClick={closeMobileMenu}>
                  Download Brochure
                </a>
              </div>
            </div>
          </>
        )}

        <div className="constik-nav">
          <div className="container">
            <nav className="navbar navbar-expand-md navbar-light">
              <div className="collapse navbar-collapse mean-menu">
                <Link to="/" className="navbar-brand">
                  <img src="/assets/img/ddlogo1.webp" width="180" height="82" alt="Logo" />
                </Link>
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link to="/" className={`nav-link ${isActive('/')}`}>
                      Home
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/projects" className={`nav-link ${isActive('/projects')}`}>
                      Our Projects
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/about" className={`nav-link ${isActive('/about')}`}>
                      About Us
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/contact" className={`nav-link ${isActive('/contact')}`}>
                      Contact Us
                    </Link>
                  </li>
                </ul>

                <div className="side-option ml-auto">
                  <div className="item">
                    <div className="cta-btn">
                      <a className="primary-btn" target="_blank" href="/assets/dp.pdf" rel="noreferrer">
                        Download Brochure
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
